import React from "react";
import Footer from "./Footer";
import NavBar from "./Navbar";
import Details from "./Details";
import Tvseries from "./Tvseries";

function MovieDetails() {
  return (
    <>
      <NavBar />
      <Details />
      <Tvseries />
      <Footer />
    </>
  );
}

export default MovieDetails;
